module.exports = __webpack_public_path__ + "static/media/oberflex-zebranogrisgalet-1200x2490.ca4f7e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranogrisgalet-1200x2490.jpg
// module id = 1082
// module chunks = 37